import { Record, List } from 'immutable';
import type ErrorRecord from '~/data/ErrorRecord';
import type { UserRoleFields } from '~/components/containers/UserManagementContainer/data/UserRole';

const keys: Fields = {
  isLoading: false,
  availableRoles: List(),
  error: undefined,
};

interface Fields {
  isLoading: boolean;
  availableRoles: List<UserRoleFields>;
  error?: ErrorRecord;
}

export default class UserRolesRecord extends Record<Fields>(keys) {}
